import React, { useEffect, useState, useMemo, FC } from "react";
import { Link } from "react-router-dom";

import { Col, Row, Button } from "reactstrap";
import DataTable from "../../shared/base-components/DataTable";
import {
  BUY_SELL_TYPES,
  MODAL_TYPES,
  Permissions,
  RESPONSE_CODE,
} from "../../shared/models/Types";
import { Personel, StaffListResponse } from "./Stock.constants";
import DeviceModal from "./DeviceModal";
import DeviceDeleteModal from "./DeviceDeleteModal";
import DeviceBuySellModal from "./DeviceBuySellModal";
import { UseMutateFunction } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { SupplierListResponse } from "../Supplier/Supplier.constants";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../shared/actions/Authentication.actions";
import DeviceDetailModal from "./DeviceDetailModal";

export interface DeviceListProps {
  deviceListData: any;
  supplierData?: SupplierListResponse | undefined;
  isDeviceListLoading?: boolean;
  deviceListMutation: UseMutateFunction<
    StaffListResponse,
    AxiosError<any>,
    any,
    unknown
  >;
}

const DeviceList: FC<DeviceListProps> = ({
  deviceListData,
  deviceListMutation,
  isDeviceListLoading,
}) => {
  const isMobile: boolean = /iPhone|iPad|iPod|Android/i.test(
    navigator.userAgent
  );
  const permissionList = useRecoilValue(permissionsSelector);

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [modalOptions, setModalOptions] = useState<{
    data?: Personel;
    modalType?: string;
  }>({
    data: undefined,
    modalType: undefined,
  });
  const [isBuySellModalOpen, setBuySellIsModalOpen] = useState<boolean>(false);
  const [buySellModalOptions, setBuySellModalOptions] = useState<{
    id?: string;
    modalType?: string;
  }>({
    id: undefined,
    modalType: undefined,
  });

  const toggle = () => {
    setIsModalOpen(!isModalOpen);
  };

  const buySellToggle = () => {
    setBuySellIsModalOpen(!isBuySellModalOpen);
  };

  const buySellModalOptionsHandler = (id?: string, modalType?: string) => {
    setBuySellModalOptions({ id: id, modalType: modalType });
  };

  const modalOptionsHandler = (data?: any, modalType?: string) => {
    setModalOptions({ data: data, modalType: modalType });
  };

  const addPermission = permissionList[Permissions.AddDevice];
  const updatePermission = permissionList[Permissions.ChangeDevice];
  const viewPermission = permissionList[Permissions.ViewDevice];
  const deletePermission = permissionList[Permissions.DeleteDevice];

  const addPermissionBuySell = permissionList[Permissions.AddDevicebuysell];

  const columns = useMemo(
    () => [
      {
        Header: "Cihaz Adı",
        filterable: false,
        disableFilters: true,
        accessor: "name",
        Cell: (response: any) => (
          <>
            <p className="text mb-0">{response.row.original?.name}</p>
          </>
        ),
      },
      {
        Header: "Stokta Kalan",
        filterable: false,
        disableFilters: true,
        accessor: "remaining_stock",
        Cell: (response: any) => (
          <>
            <h5 className="font-size-14 mb-1">
              {response.row.original?.remaining_stock}
            </h5>
          </>
        ),
      },
      {
        Header: "Toplam Alış",
        filterable: false,
        disableFilters: true,
        accessor: "total_bought",
        Cell: (response: any) => (
          <>
            <h5 className="font-size-14 mb-1">
              {response.row.original?.total_bought}
            </h5>
          </>
        ),
      },
      {
        Header: "Toplam Satış",
        filterable: false,
        disableFilters: true,
        accessor: "total_sold",
        Cell: (response: any) => (
          <>
            <h5 className="font-size-14 mb-1">
              {response.row.original?.total_sold}
            </h5>
          </>
        ),
      },
      {
        Header: "Kurulumda Kullanılan",
        filterable: false,
        disableFilters: true,
        accessor: "total_use_in_setup",
        Cell: (response: any) => (
          <>
            <h5 className="font-size-14 mb-1">
              {response.row.original?.total_use_in_setup}
            </h5>
          </>
        ),
      },
      {
        Header: "Al/Sat",
        filterable: false,
        disableFilters: true,
        accessor: "system",
        Cell: (response: any) => (
          <>
            <h5 className="d-flex font-size-14 mb-1">
              <span
                onClick={() => {
                  buySellModalOptionsHandler(
                    response.row.original?.id,
                    BUY_SELL_TYPES.BUY
                  );

                  buySellToggle();
                }}
                className="btn bg-danger badge me-2 p-2"
              >
                Al
              </span>
              <span
                onClick={() => {
                  buySellModalOptionsHandler(
                    response.row.original?.id,
                    BUY_SELL_TYPES.SELL
                  );

                  buySellToggle();
                }}
                className="btn bg-success badge me-2 p-2"
              >
                Sat
              </span>
            </h5>
          </>
        ),
      },
      {
        Header: "İşlemler",
        Cell: (cellProps: any) => {
          return (
            <div className="d-flex gap-3">
              {updatePermission && (
                <Link className="text-warning" to="#">
                  <i
                    className="mdi mdi-pencil font-size-18"
                    id="edittooltip"
                    onClick={() => {
                      const deviceDat = cellProps.row.original;

                      toggle();
                      modalOptionsHandler(deviceDat, MODAL_TYPES.UPDATE);
                    }}
                  ></i>
                </Link>
              )}

              {deletePermission && (
                <Link className="text-danger" to="#">
                  <i
                    className="mdi mdi-delete font-size-18"
                    id="deletetooltip"
                    onClick={() => {
                      const deviceDat = cellProps.row.original;

                      toggle();
                      modalOptionsHandler(deviceDat, MODAL_TYPES.DELETE);
                    }}
                  ></i>
                </Link>
              )}
            </div>
          );
        },
      },
    ],
    []
  );

  const mobileColumns = useMemo(
    () => [
      {
        Header: "Cihaz Adı",
        filterable: false,
        disableFilters: true,
        accessor: "name",
        Cell: (response: any) => (
          <>
            <p className="text mb-0">{response.row.original?.name}</p>
          </>
        ),
      },
      {
        Header: "Al/Sat",
        filterable: false,
        disableFilters: true,
        accessor: "system",
        Cell: (response: any) => (
          <>
            <h5 className="d-flex font-size-14 mb-1">
              <span
                onClick={() => {
                  buySellModalOptionsHandler(
                    response.row.original?.id,
                    BUY_SELL_TYPES.BUY
                  );

                  buySellToggle();
                }}
                className="btn bg-danger badge me-2 p-2"
              >
                Al
              </span>
              <span
                onClick={() => {
                  buySellModalOptionsHandler(
                    response.row.original?.id,
                    BUY_SELL_TYPES.SELL
                  );

                  buySellToggle();
                }}
                className="btn bg-success badge me-2 p-2"
              >
                Sat
              </span>
            </h5>
          </>
        ),
      },
      {
        Header: "İşlemler",
        Cell: (cellProps: any) => {
          return (
            <div className="d-flex gap-3">
              {updatePermission && (
                <Link className="text-warning" to="#">
                  <i
                    className="mdi mdi-pencil font-size-18"
                    id="edittooltip"
                    onClick={() => {
                      const deviceDat = cellProps.row.original;

                      toggle();
                      modalOptionsHandler(deviceDat, MODAL_TYPES.UPDATE);
                    }}
                  ></i>
                </Link>
              )}

              {deletePermission && (
                <Link className="text-danger" to="#">
                  <i
                    className="mdi mdi-delete font-size-18"
                    id="deletetooltip"
                    onClick={() => {
                      const deviceDat = cellProps.row.original;

                      toggle();
                      modalOptionsHandler(deviceDat, MODAL_TYPES.DELETE);
                    }}
                  ></i>
                </Link>
              )}

              <Link className="text-success" to="#">
                <i
                  className="mdi mdi-eye font-size-18"
                  id="deletetooltip"
                  onClick={() => {
                    const userData = cellProps.row.original;

                    toggle();
                    modalOptionsHandler(userData, MODAL_TYPES.DETAIL);
                  }}
                ></i>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <Row className="align-items-center">
        <Col md={6}>
          <div className="mb-3">
            <h5 className="card-title">Cihaz Listesi</h5>
          </div>
        </Col>

        <Col md={6}>
          <div className="d-flex flex-wrap align-items-center justify-content-end gap-2 mb-3">
            <div>
              <ul className="nav nav-pills"></ul>
            </div>
            <div>
              {addPermission && (
                <Button
                  onClick={() => {
                    toggle();
                    modalOptionsHandler(undefined, MODAL_TYPES.CREATE);
                  }}
                  className="btn btn-light"
                >
                  <i className="bx bx-plus me-1"></i> Cihaz Ekle
                </Button>
              )}
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col lg="12">
          {deviceListData?.length && viewPermission ? (
            <DataTable
              columns={isMobile ? mobileColumns : columns}
              data={deviceListData}
              isGlobalFilter={true}
              isAddUserList={true}
              customPageSize={10}
              className="table align-middle datatable dt-responsive table-check nowrap"
            />
          ) : (
            !isDeviceListLoading && <>Herhangi bir cihaz bulunmamaktadır.</>
          )}
        </Col>
      </Row>

      {isModalOpen &&
        updatePermission &&
        (modalOptions.modalType === MODAL_TYPES.CREATE ||
          modalOptions.modalType === MODAL_TYPES.UPDATE) && (
          <DeviceModal
            deviceData={modalOptions.data}
            modalType={modalOptions.modalType}
            isModalOpen={isModalOpen}
            toggle={toggle}
            deviceListMutation={deviceListMutation}
          />
        )}

      {isBuySellModalOpen && addPermissionBuySell && (
        <DeviceBuySellModal
          modalData={buySellModalOptions}
          isModalOpen={isBuySellModalOpen}
          toggle={buySellToggle}
          deviceListMutation={deviceListMutation}
        />
      )}

      {isModalOpen &&
        deletePermission &&
        modalOptions.modalType === MODAL_TYPES.DELETE && (
          <DeviceDeleteModal
            userData={modalOptions.data}
            modalType={modalOptions.modalType}
            isModalOpen={isModalOpen}
            toggle={toggle}
            deviceListMutation={deviceListMutation}
          />
        )}

      {isModalOpen && modalOptions.modalType === MODAL_TYPES.DETAIL && (
        <DeviceDetailModal
          userData={modalOptions.data}
          modalType={modalOptions.modalType}
          isModalOpen={isModalOpen}
          toggle={toggle}
        />
      )}
    </React.Fragment>
  );
};

export default DeviceList;
